export default __webpack_public_path__ + "static/media/oil.a99d19b9.png";